import { CountCellProps } from '../../types';
import { formatNumberWithComma } from 'utils';

const DaysCountsCell = ({ _customRowProps, data }: CountCellProps) => {
  const { dayscount } = data;

  return <div>{formatNumberWithComma(+dayscount)}</div>;
};

export default DaysCountsCell;
